export default {
  'discount.title': 'Mức chiết khấu',
  'discount.minRevenue': 'Doanh thu tối thiểu (VNĐ)',
  'discount.discountLevel': 'Mức chiết khấu',
};
